import React from 'react';
import Overlay from 'Components/Overlay';
import Select from 'react-select';

const AddCostHeadPopup = (props) => ( 
    <Overlay>
        <div className="bg-light-blue box-shadow ph-20 pv-20 br-5 tCenter">
            <div className="mb-10 tCenter fSemibold fs-20 mt-10 mb-10">
                {'Add Cost Heads'} 
            </div>
             <div className='mb-50 mt-20'>
                <div>
                    {/* <div className="mb-10 tCenter header-medium-color fSemibold fs-14">
                       Cost Head
                    </div> */}
                    <Select 
                        isMulti
                        // className="wt-250"
                        value={props.selectedCostHeads || null}
                        options={props.costHeadsOptions}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        onChange = {props.onSelectCostHead}
                    />
                </div>
            </div>
            <div className="col-1 ht-60 flex flex-middle flex-center">
                <button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30" onClick={props.onCancel}>Cancel</button>
                <button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30" onClick={props.onAdd}>Add</button>
            </div>
        </div>
    </Overlay>
);

export default AddCostHeadPopup;